import { cn } from '@/utils/cn'
import { formatSlaLabel, getSlaBadgeTone, SLA_BADGE_CLASS } from './financeSla.util'

type Props = {
  slaDueAt: string | null | undefined
  status: string
  className?: string
}

export function FinanceSlaBadge({ slaDueAt, status, className }: Props) {
  const tone = getSlaBadgeTone(slaDueAt, status)
  return (
    <span
      className={cn(
        'inline-flex rounded-full px-2 py-0.5 text-xs font-medium',
        SLA_BADGE_CLASS[tone],
        className,
      )}
    >
      {formatSlaLabel(slaDueAt, tone)}
    </span>
  )
}
